import { api } from "@/lib/api/axios"
import { UserAuthenticated } from "@/types/auth"
import { RegisterUsers, Role } from "@/types/users"

const USERS_API_PATH = '/users'

export const usersService = {
  register: async (payload: RegisterUsers) => {
    return api.post<{ id_user: number | string }>(`${USERS_API_PATH}/register`, payload)
  },
  me: async () => {
    return api.get<UserAuthenticated>(`${USERS_API_PATH}/me`)
  },
  changeRole: async (id: number, role: Role) => {
    return api.patch<{
      user: {
        id: number,
        login: string,
        role: Role,
      },
    }>(`${USERS_API_PATH}/${id}/role/`, { newRoleId: role.valueOf() })
  },
  updateOnboardingStep: async ({ id_user, step }: { id_user: number, step: string }) => {
    return api.patch<{
      user: {
        id: number,
        login: string,
        onboarding_steps: string,
      }
    }>(`${USERS_API_PATH}/${id_user}/onboarding-steps`, { newStep: step })
  }
}